import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const budgetAtomData = atom({
  key: 'budgetAtom_Data',
  default: {
    budget_info: [],
    financial_year: [],
    budget_term: [],
  },
});

const budgetEditAtom = atom({ key: 'budgetAtom_edit', default: {} });

export const SetBudgetListData = () => useSetRecoilState(budgetAtomData);
export const GetBudgetListData = () => useRecoilValue(budgetAtomData);

export const SetBudgetEdit = () => useSetRecoilState(budgetEditAtom);
export const GetBudgetEdit = () => useRecoilValue(budgetEditAtom);
